const ResortsReducer = (state, action) => {
    switch (action.type) {
        case "GET_RESORTS_INIT":
            return {
                ...state,
                resortsLoading: true,
                init: action?.payload
            };
        case "GET_RESORTS_SUCCESS":
            return {
                ...state,
                resortsLoading: false,
                resorts: action?.payload
            };
        case "GET_RESORTS_ERROR":
            return {
                ...state,
                resortsLoading: false,
                error: action?.payload
            };
        default:
            return state;
    }
};

export default ResortsReducer;

